export const SPEED_HIGH = 600
export const SPEED_MODERATE = 500
export const SPEED_MEDIUM = 300

export const BZ_HIGH = -5
export const BZ_MODERATE = -2.5
export const BZ_MEDIUM = 0

export const DENSITY_HIGH = 10
export const DENSITY_MODERATE = 6
export const DENSITY_MEDIUM = 2

export const KPI_HIGH = 5
export const KPI_MODERATE = 4
export const KPI_MEDIUM = 3

export const MAG_SOUTH_HIGH = -50
export const MAG_SOUTH_MODERATE = -25
export const MAG_SOUTH_MEDIUM = -10

export const MAG_NORTH_HIGH = -100
export const MAG_NORTH_MODERATE = -50
export const MAG_NORTH_MEDIUM = -25

export interface Thresholds {
  high: number
  medium: number
  moderate: number
}

export const MAG_SOUTH_THRESHOLDS = {
  high: MAG_SOUTH_HIGH * -1,
  moderate: MAG_SOUTH_MODERATE * -1,
  medium: MAG_SOUTH_MEDIUM * -1,
}

type MagNorthThresholds = Record<string, number>
export const MAG_NORTH_THRESHOLDS: MagNorthThresholds = {
  high: MAG_NORTH_HIGH * -1,
  moderate: MAG_NORTH_MODERATE * -1,
  medium: MAG_NORTH_MEDIUM * -1,
}

type MagThresholds = Record<string, any>
export const MAG_THRESHOLDS: MagThresholds = {
  ouj: MAG_NORTH_THRESHOLDS,
  muo: MAG_NORTH_THRESHOLDS,
  iva: MAG_NORTH_THRESHOLDS,
  nur: MAG_SOUTH_THRESHOLDS,
}

export const SPEED_THRESHOLDS = {
  high: SPEED_HIGH,
  moderate: SPEED_MODERATE,
  medium: SPEED_MEDIUM,
}

export const BZ_THRESHOLDS = {
  high: BZ_HIGH * -1, // Reversed for unified logic in Status.js
  moderate: BZ_MODERATE * -1, // -- || --
  medium: BZ_MEDIUM,
}

export const DENSITY_THRESHOLDS = {
  high: DENSITY_HIGH,
  moderate: DENSITY_MODERATE,
  medium: DENSITY_MEDIUM,
}

export const KPI_THRESHOLDS = {
  high: KPI_HIGH,
  moderate: KPI_MODERATE,
  medium: KPI_MEDIUM,
}
